export default __webpack_public_path__ + "static/media/eye-no.74d08956.svg";